import type { IconProp } from '~/modules';
import {
  StepsItem,
  StepsItemDescription,
  StepsItemIcon,
  StepsList,
  StepsTitle,
} from './styles';

type Props = {
  title?: string;
  items: {
    icon: IconProp;
    description: string;
  }[];
};

const Steps = ({ title, items }: Props) => {
  return (
    <>
      <StepsTitle>{title}</StepsTitle>
      <StepsList>
        {items.map((item) => (
          <StepsItem key={item.description}>
            <StepsItemIcon icon={item.icon} />
            <StepsItemDescription>{item.description}</StepsItemDescription>
          </StepsItem>
        ))}
      </StepsList>
    </>
  );
};

export default Steps;
